export const PROMO_SELLING_TARGET = {
  PROMOS: 'promos',
  ACTUAL_PROMOS: 'actualPromos'
};
